import type { IconProps } from './../../models/icon';

export function ChevronLeftIcon({
  width = 24,
  height = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M17.3998 0.857117L6.85692 11.4C6.77492 11.4769 6.70957 11.5699 6.6649 11.6731C6.62023 11.7763 6.59717 11.8875 6.59717 12C6.59717 12.1124 6.62023 12.2237 6.6649 12.3269C6.70957 12.4301 6.77492 12.523 6.85692 12.6L17.3998 23.1428"
      />
    </svg>
  );
}
